module.exports = __webpack_public_path__ + "img/icon_mine_help@2x.e02b68a9.png";